import React from "react"
import { RadioBox } from "../helper";
import { Translate } from "react-localize-redux";

export class NoiseType extends RadioBox {
	constructor(props) {
		super(props, props.setState)
	}
	render() {
		return (
			<Translate key={this.props.template.id}>
				{({ translate }) => 
					<div className="oc-form-group-wrapper">
						<h6>{ this.props.template.name }</h6>
                        <ul>
                            <li>
                                <label
                                    className={`
                                        oc-form-label
                                        ${this.state.value === 'คงที่' ? 'active': ''}
                                    `.trim()}
                                >
                                    {translate('form_audio_noise_type_constant')}
                                    <input
                                        name={`${this.props.template.id}`}
                                        type="radio"
                                        value="คงที่"
                                        checked={this.state.value === 'คงที่'}
                                        onChange={(e) => this.onChangeHandler(e)}
                                    />
                                </label>
                            </li>
                            <li>
                                <label
                                    className={`
                                        oc-form-label
                                        ${this.state.value === 'กระแทก' ? 'active': ''}
                                    `.trim()}
                                >
                                    {translate('form_audio_noise_type_burst')}
                                    <input
                                        name={`${this.props.template.id}`}
                                        type="radio"
                                        value="กระแทก"
                                        checked={this.state.value === 'กระแทก'}
                                        onChange={(e) => this.onChangeHandler(e)}
                                    />
                                </label>
                            </li>
                        </ul>
					</div>
				}
			</Translate>
		)
	}
}